import { render, staticRenderFns } from "./NavBarIV.vue?vue&type=template&id=06b4948b&"
import script from "./NavBarIV.vue?vue&type=script&lang=js&"
export * from "./NavBarIV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports